import _ from '/home/ps/root'
import {cache, Route, cookies} from '../global'
const route = Route()
export const lang = _.LANG_.includes(route[0]) ? route[0] : _.EN
export const dir = _.RTL_.includes(lang) ? 'rtl' : 'ltr'
const cookie = cookies()
const q = {
  id: _.QID,
  modified: 0,
  // home: user.home || user.p || 20,
  home: cookie.p || 20,
  username: 'q',
  password: '[]',
  name: 'Business Queue',
  phone: '[]',
  email: '[]',
  json: '[]',
}
cache('q', q)
cache('q[]', Object.values(q))
export const initialState = {
  park: {}, // park
  p: {}, // parking
  // [_.SCREEN]: {[_.WIDTH]: window.innerWidth, [_.HEIGHT]: window.innerHeight},
  dir,
  lang,
  slide: {
    id: '',
    state: 'hide',
  },
  // [_.FETCH]: {},
  // [_.LOGIN]: false,
  // login: false,
  // [_.GO]: {},
  select: false,
  init: {},
  // [_.MOUNT]: false,
  io: {},
  purchase: false,
  online: {},//[_.VENDOR]: {}, [_.CUSTOMER]: {}, [_.EMPLOYEE]: {}, [_.SHIPPER]: {}},
  find: {},
  new: {},
  user: {},
  q: {},
  buy: q,
  // [_.CONNECT]: {[_.ID]: 0, [_.CONNECT]: false, [_.USER]:{}},
}
export default initialState
